<template>
  <b-overlay
      :show="loading"
      rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
            title="جزئیات مقاله"
        >
            <b-form               ref="blogform"
                                  @submit.prevent>
                <b-row>
                    <b-col
                            class="mt-2 form-size"
                            md="8"
                    >
                        <b-row>
                            <b-tabs>

                                <b-tab title="اطلاعات">
                                    <b-row class="mt-2">
                            <b-col
                                    class="image"
                                    cols="12"
                            >
                                <b-media class="mb-2">
                                    <template #aside>
                                        <b-avatar
                                                ref="previewEl"
                                                :src="Form.Image"
                                                size="90px"
                                                rounded
                                                button
                                                @click="$refs.refInputEl.click()"
                                        />
                                    </template>
                                    <input
                                            :ref="'refInputEl'"
                                            type="file"
                                            class="d-none"
                                            name="Image"
                                            @input="imageRenderer($event)"
                                    >
                                    <b-row>
                                        <b-col md="10">
                                            <b-form-group
                                                    label="عنوان"
                                                    label-for="Title"
                                                    class="mb-0"
                                            >
                                                <b-form-input
                                                        id="Title"
                                                        v-model="Form.Title"
                                                        name="Title"
                                                        autocomplete="off"
                                                />
                                            </b-form-group>
                                        </b-col>
                                        <b-col md="2">
                                            <b-form-group
                                                    label="ترتیب"
                                                    label-for="Sort"
                                                    class="mb-0"
                                            >
                                                <b-form-input
                                                        id="Sort"
                                                        v-model="Form.Sort"
                                                        name="Sort"
                                                        autocomplete="off"
                                                />
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-media>
                            </b-col>

                            <b-col md="4">
                                <b-form-group
                                        label="وضعیت"
                                        label-for="Visibility"
                                >
                                    <v-select
                                            v-model="Form.Visibility"
                                            :options="enums('IsActive')"
                                            dir="rtl"
                                            label="text"
                                            name="Visibility"
                                            :clearable="false"
                                            :reduce="x => x.value"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                        label="دسته بندی"
                                        label-for="BlogCategoryId"
                                >
                                    <z-blog-category
                                            v-model="Form.BlogCategoryId"
                                            :multiple="false"
                                            :clearable="false"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="4">
                                <b-form-group
                                        label="نویسنده"
                                        label-for="Author"
                                >
                                    <b-form-input
                                            id="Author"
                                            name="Author"
                                            v-model="Form.Author"
                                            autocomplete="off"
                                    />
                                </b-form-group>

                            </b-col>
                            <b-col cols="12">
                                <b-form-group
                                        label="تگ ها"
                                        label-for="Tags"
                                >
                                    <b-form-tags
                                            v-model="Form.Tags"
                                            name="Tags"
                                            placeholder=""
                                            add-button-text="افزودن"
                                            add-button-variant="outline-primary"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="12">
                                <b-form-group
                                        label="خلاصه"
                                        label-for="MetaDescription"
                                >
                                    <b-form-textarea
                                            id="MetaDescription"
                                            v-model="Form.MetaDescription"
                                            name="MetaDescription"
                                            rows="5"
                                            no-resize
                                    />
                                </b-form-group>
                            </b-col>

                                    </b-row>
                                </b-tab>

                                <b-tab title="محتوا">
                                    <b-row class="mt-2">
                                        <b-col md="12">
                                            <b-form-group
                                                label-for="Description"
                                            >
                                                <quill-editor
                                                    v-model="Form.Description"
                                                    id="Description"
                                                    :options="snowOption"
                                                    @change="editorIsChange"
                                                />
                                            </b-form-group>
                                        </b-col>
                                    </b-row>
                                </b-tab>
                                <b-tab title="سوالات متداول">
                                    <b-row class="mt-2">
                                        <b-col cols="12">
                                            <b-row
                                                v-for="(item, index) in Form.BlogFaq"
                                                :key="index"
                                            >

                                                <b-col md="10">
                                                    <b-form-group
                                                        label="سوال"
                                                    >
                                                        <b-form-input
                                                            v-model="item.Title"
                                                            autocomplete="off"
                                                        />
                                                    </b-form-group>
                                                </b-col>

                                                <b-col
                                                    md="2"
                                                    class="mb-1"
                                                    style="display: flex; align-items: flex-end;"
                                                >
                                                    <template v-if="blogFaqRemoveId !== index">
                                                        <b-button
                                                            v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                                                            variant="outline-danger"
                                                            class="btn-icon rounded-circle"
                                                            @click="removeBlogFaq(index)"
                                                        >
                                                            <feather-icon
                                                                icon="TrashIcon"
                                                            />
                                                        </b-button>
                                                    </template>
                                                    <template v-else>
                                                        <b-button
                                                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                            class="btn-icon rounded-circle"
                                                            variant="outline-primary"
                                                            @click="cancelBlogFaq"
                                                        >
                                                            <feather-icon icon="XIcon" />
                                                        </b-button>
                                                        <b-button
                                                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                            class="btn-icon rounded-circle ml-1"
                                                            variant="outline-primary"
                                                            @click="confirmBlogFaq"
                                                        >
                                                            <feather-icon icon="CheckIcon" />
                                                        </b-button>
                                                    </template>
                                                </b-col>

                                                <b-col cols="12">
                                                    <b-form-group
                                                        label="پاسخ"
                                                        label-for="Description"
                                                    >
                                                        <div class="form-label-group">
                                                            <b-form-textarea
                                                                id="Description"
                                                                v-model="item.Description"
                                                                autocomplete="off"
                                                                rows="3"
                                                                no-resize
                                                            />
                                                        </div>
                                                    </b-form-group>
                                                </b-col>

                                                <b-col cols="12">
                                                    <hr>
                                                </b-col>
                                            </b-row>
                                        </b-col>

                                        <b-col>
                                            <b-button
                                                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                                variant="gradient-info"
                                                @click="addBlogFaq"
                                            >
                                                <feather-icon
                                                    icon="PlusIcon"
                                                    class="mr-25"
                                                />
                                                <span>افزودن</span>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                </b-tab>


                            </b-tabs>

                            <b-col cols="12">
                                <hr>
                            </b-col>
                            <b-col md="12" class="mt-1 mb-2 text-center">
                                <b-button
                                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                                    type="submit"
                                    variant="primary"
                                    class="mr-1"
                                    @click="save"
                                >
                                    ذخیره
                                </b-button>
                                <b-button
                                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                    variant="outline-secondary"
                                    @click="back"
                                >
                                    بازگشت
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-form>


        </b-card>
      </b-col>
    </b-row>
    <b-modal
        v-model="showModalImageAttr"
        ok-title="ذخیره"
        cancel-title="انصراف"
        cancel-variant="outline-secondary"
        centered
        title="اضافه کردن  alt به تصویر"
        :no-close-on-backdrop="true"
        size="sm"
        @ok="addImageAttr"
    >
      <b-row>
        <b-col md="12">
          <b-form-group
              label="Alt"
              label-for="Alt"
          >
            <b-form-input
                id="Alt"
                v-model="AltTemp"
                name="Title"
                autocomplete="off"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
<!--    <b-modal-->
<!--        v-model="showModalLinkAttr"-->
<!--        ok-title="دنبال نشود"-->
<!--        cancel-title="دنبال بشود"-->
<!--        cancel-variant="outline-secondary"-->
<!--        centered-->
<!--        title="اضافه کردن  attribute به لینک"-->
<!--        :no-close-on-backdrop="true"-->
<!--        size="sm"-->
<!--        @ok="addLinkAttr"-->
<!--        @cancel="closeLinkAttrModal()"-->
<!--    >-->
<!--      <div >-->
<!--        <p>آیا این  لینک توسط موتور جستجو دنبال بشود یا نشود</p>-->
<!--      </div>-->
<!--    </b-modal>-->
  </b-overlay>
</template>

<script>

import ZBlogCategory from '@/tools/blogcategory.vue'
import { quillEditor } from 'vue-quill-editor'
import uploadFile from '@/tools/uploadFile'
let converter = require('json-2-csv');
export default {
  name: 'BlogDetails',
  components: {
    quillEditor,
    ZBlogCategory,
    uploadFile
  },
  data() {
    return {
      Schemas:[],
      Form: {
        Id: 0,
        Title: '',
        MetaTitle:'',
        Description: '',
        Image: null,
        Video: null,
        Visibility: true,
        BlogFaq: [],
        Tags:[],
        BriefDescription:'',
        MetaDescription: '',
        ImageAlt:'',
        Canonical:'',
        IndexPost:true,
        Schemas:[],
        Type: 0,
        Url:'',
        BlogContentType: 0,
        Sort: 0,
      },
      loading: false,
      snowOption: {
        theme: 'snow',
        // modules: {
        //   toolbar: ['bold', 'italic', 'underline','image','header','align','link','color','indent', 'list']
        // },
      },
      showModalImageAttr: false,
      showModalLinkAttr: false,
      AltTemp: null,
      elementTemp: null,
        blogFaqRemoveId: null
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.blog.add
      if (this.$route.params.id) {
        url = this.$api.blog.update
      }

        const formData = new FormData(this.$refs.blogform)

        formData.append('Id', this.Form.Id)
        formData.append('Visibility', this.Form.Visibility)
        formData.append('Description', this.Form.Description)
        formData.append('BlogCategoryId', this.Form.BlogCategoryId)

        this.Form.BlogFaq.forEach((item, index) => {
                formData.append(`BlogFaq[${index}].Title`, item.Title)
                formData.append(`BlogFaq[${index}].Description`, item.Description)
        })

        this.loading = true
        this.$http.post(
            url, formData,
        )
            .then(() => {
                   this.back()
            })
            .finally(() => {
              this.loading = false
            })
    },
    editorIsChange(){
      document.querySelectorAll('#Description img').forEach(img => {
        img.onclick= (e)=>{
            console.log('ggg')
          this.elementTemp = e
            this.AltTemp= e.target.getAttribute('alt')
          this.showModalImageAttr = true
        }
      })
      document.querySelectorAll('#Description a').forEach(a => {
        a.onclick= (e)=>{
          this.elementTemp = e
          this.showModalLinkAttr = true
        }
      })
    },
    get() {
      this.loading = true
      this.$http.post(
          this.$api.blog.get, {
            Id: this.Form.Id,
          },
      )
          .then(res => {
            this.loading = false
            this.Form = res.data
            this.Schemas = this.Form.Schemas
          })
    },
      imageRenderer(event) {
          const fileReader = new FileReader()
          fileReader.readAsDataURL(event.target.files[0])

          fileReader.onload = () => {
              this.Form.Image = fileReader.result
          }
      },
    addImageAttr(){
      this.elementTemp.target.setAttribute('alt',this.AltTemp)
      this.showModalImageAttr = false
    },
    addLinkAttr(){
      this.elementTemp.target.setAttribute('rel','nofollow')
      this.showModalImageAttr = false
    },
    closeLinkAttrModal(){
      this.elementTemp.target.setAttribute('rel',' ')
    },
      addBlogFaq() {
          this.Form.BlogFaq.push({ Title: null, Description: null })
      },
      removeBlogFaq(index) {
          this.blogFaqRemoveId = index
      },
      confirmBlogFaq() {
          this.Form.BlogFaq.splice(this.blogFaqRemoveId, 1)
          this.blogFaqRemoveId = null
      },
      cancelBlogFaq() {
          this.blogFaqRemoveId = null
      },
  },
}
</script>

<style scoped>

[dir=rtl] .input-group-url  {
  direction: ltr;
}

[dir=rtl] .input-group-url .input-group-prepend {
  margin-left: 0 !important;
  margin-right: -1px !important;
}

[dir=rtl] .input-group-url .input-group-text {
  border-top-left-radius: 0.357rem !important;
  border-bottom-left-radius: 0.357rem !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-left: 1px solid #d8d6de;
}

[dir=rtl] .input-group-url .form-control {
  border-top-right-radius: 0.357rem !important;
  border-bottom-right-radius: 0.357rem !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-right: 1px solid #d8d6de !important;
  padding: 0.438rem 1rem !important;
}

[dir=rtl] .input-group-url .form-control:focus-within {
border-right: 1px solid #7367f0 !important;
}

.media {
    display: flex;
    align-items: flex-end;
}


</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/quill.scss';
@import '@core/scss/vue/pages/page-blog.scss';
</style>
